import {API_URL, DIST_ID, DIST_BUILD} from '@/constants/app.constant'
import {getSessionId} from '@/features/context/SessionContext'


export async function getUsers({
                                   pageIndex = 1,
                                   pageSize = 25,
                                   query = "",
                                   sort = {
                                       order: 'desc',
                                       key: 'createdAt',
                                   },
                                   filterData = {},
                                   ...payload
                               }) {

    const response = await fetch(`${API_URL}/users`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        body: JSON.stringify({
            pageIndex,
            pageSize,
            query,
            sort,
            filterData,
            ...payload
        })
    }).catch(err => {
        let message = err.message

        if (message == 'Failed to fetch')
            message = !navigator?.onLine ? 'اتصال اینترنت شما قطع است!' : 'در حال حاضر امکان ارتباط با سرور وجود ندارد!'

        throw new Error(message)
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function getUsersStatistics() {
    const response = await fetch(`${API_URL}/users/statistics`, {
        method: 'GET',
        headers: {
            // 'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    });

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function getUser({id}) {
    const response = await fetch(`${API_URL}/user/${id}`, {
        method: 'GET',
        headers: {
            // 'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    })

    const data = await response.json();

    if (!response.ok)
        throw new Error(data.message || response.statusText);

    return data;
}

export async function putUsers({ids, ...user}) {
    const response = await fetch(`${API_URL}/users`, {
        method: 'PUT',
        headers: {
            // 'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            ...user,
            ids: user?.id ? [user?.id] : ids,
        })
    })

    const data = await response.json();

    if (!response.ok)
        throw new Error(data.message || response.statusText);

    return data;
}

export async function deleteUsers({ids, permanent = false}) {
    const response = await fetch(`${API_URL}/users`, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        body: JSON.stringify({
            ids,
            permanent,
        })
    }).catch(err => {
        let message = err.message

        if (message == 'Failed to fetch')
            message = !navigator?.onLine ? 'اتصال اینترنت شما قطع است!' : 'در حال حاضر امکان ارتباط با سرور وجود ندارد!'

        throw new Error(message)
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function loginAsUser({id}) {
    const response = await fetch(`${API_URL}/user/${id}/login`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        body: JSON.stringify({})
    }).catch(err => {
        let message = err.message

        if (message == 'Failed to fetch')
            message = !navigator?.onLine ? 'اتصال اینترنت شما قطع است!' : 'در حال حاضر امکان ارتباط با سرور وجود ندارد!'

        throw new Error(message)
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function getUserOrders({user, page}) {
    const response = await fetch(`${API_URL}/user/${user}/orders?page=${page}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`
        },
        // body: JSON.stringify()
    }).catch(err => {
        let message = err.message

        if (message == 'Failed to fetch')
            message = !navigator?.onLine ? 'اتصال اینترنت شما قطع است!' : 'در حال حاضر امکان ارتباط با سرور وجود ندارد!'

        throw new Error(message)
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json()

    if (typeof data.success != 'undefined' && !data.success)
        throw new Error(data.message || 'خطای غیر منتظره‌ای رخ داده!')

    return data
}

export async function getHome() {
    const response = await fetch(`${API_URL}/account/home`, {
        method: 'POST',
        headers: {
            // 'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            app: DIST_ID,
            app_version: DIST_BUILD
        })
    });

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function getAccount() {
    const response = await fetch(`${API_URL}/account`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify()
    })
    // .catch(err => {
    //     return {success: false, message: err.message}
    // });
    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    // if (typeof data.success != "undefined" && !data.success)
    //     throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function updateFCMToken({token}) {
    const response = await fetch(`${API_URL}/account/update/fcm`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            token
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function followUser({user, follow}) {
    const response = await fetch(`${API_URL}/user/${user}/follow`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            follow
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function updateAccount({formData}) {
    const response = await fetch(`${API_URL}/account/update`, {
        method: 'POST',
        headers: {
            // 'Accept': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: formData
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیرمنتظره‌ای رخ داده!");

    return data;
}

export async function updateMobileNumber({mobileNumber}) {
    const response = await fetch(`${API_URL}/account/update/mobile`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            mobileNumber,
        }),
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیرمنتظره‌ای رخ داده!");

    return data;
}


export async function confirmMobileNumber({mobileNumber, code}) {
    const response = await fetch(`${API_URL}/account/update/mobile/confirm`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            mobileNumber,
            code,
        }),
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیرمنتظره‌ای رخ داده!");

    return data;
}

export async function updatePassword({currentPassword, newPassword}) {
    const response = await fetch(`${API_URL}/account/update/password`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            currentPassword,
            newPassword,
        }),
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیرمنتظره‌ای رخ داده!");

    return data;
}


export async function getSessions({}) {
    const response = await fetch(`${API_URL}/account/sessions`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify()
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function removeSession({token}) {
    const response = await fetch(`${API_URL}/account/session`, {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            token
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function getNotifications({page = 1}) {
    const response = await fetch(`${API_URL}/account/notifications?page=${page}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function deliverNotifications({ids}) {
    const response = await fetch(`${API_URL}/account/notifications/deliver`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            ids
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function readNotifications({ids}) {
    const response = await fetch(`${API_URL}/account/notifications/read`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            ids
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function submitReport({title, message, contentType, contentId, details = null}) {
    const response = await fetch(`${API_URL}/account/reports/submit`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            title,
            message,
            contentType,
            contentId,
            details,
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function getTickets({page = 1}) {
    const response = await fetch(`${API_URL}/account/tickets/?page=${page}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}


export async function submitTicket({title, message}) {
    const response = await fetch(`${API_URL}/account/tickets/submit`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            title,
            message,
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function closeTicket({ticket}) {
    const response = await fetch(`${API_URL}/account/ticket/${ticket}/close`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({})
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}


export async function getTicket({id}) {
    const response = await fetch(`${API_URL}/account/ticket/${id}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function getTicketMessages({ticket, page = 1}) {
    const response = await fetch(`${API_URL}/account/ticket/${ticket}/messages/?page=${page}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        // body: JSON.stringify({
        // })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function postTicketsMessage({ticket, formData}) {
    const response = await fetch(`${API_URL}/account/ticket/${ticket}/post`, {
        method: 'POST',
        headers: {
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: formData
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}


export async function getAccountOrder({id}) {
    const response = await fetch(`${API_URL}/account/order/${id}`, {
        method: 'GET',
        headers: {
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}

export async function verifyAccountOrder({id, ...order}) {
    const response = await fetch(`${API_URL}/account/order/${id}/verify`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionId()}`,
        },
        body: JSON.stringify({
            ...order
        })
    })

    // if (!response.ok)
    //     throw new Error(response.statusText);

    let data = await response.json();

    if (typeof data.success != "undefined" && !data.success)
        throw new Error(data.message || "خطای غیر منتظره‌ای رخ داده!");

    return data;
}
